import ScrollContainer from "react-indiana-drag-scroll";
import styled from "styled-components";

import { Container } from "components/ui";

import { media } from "constants/media";

export const Wrapper = styled.div`
    background: var(--color-orange-40);
    padding: 40px 0;
    position: relative;

    ${media.mdUp} {
        padding: 80px 0;
    }
`;

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
export const StyledScrollContainer = styled(ScrollContainer)`
    cursor: grab;
    display: flex;
    gap: 24px;
    height: 324px;
    padding-top: 12px;
    position: relative;
    width: 100%;

    ${media.mdUp} {
        gap: 32px;
        height: 424px;
    }
`;

export const StyledContainer = styled(Container)<{ boxHeight: number }>`
    display: block;
    min-height: 372px;
    position: relative;

    &::after {
        /* stylelint-disable*/
        background: linear-gradient(
                -90deg,
                var(--color-orange-40) 0%,
                transparent
            )
            100%;
        /* stylelint-enable*/
        content: "";
        display: block;
        height: 100%;
        position: absolute;
        right: 20px;
        top: 0;
        width: 48px;

        ${media.mdUp} {
            right: 24px;
        }
    }
`;

export const Title = styled.h2`
    font-weight: normal;
    margin-bottom: 24px;

    /* stylelint-disable-next-line */
    ${media.mdUp} {
        margin-bottom: 16px;
    }
`;

export const SliderWrapper = styled.div`
    > div {
        padding: 8px 0;
    }
`;

export const Top = styled.div`
    align-items: center;
    display: flex;
    justify-content: space-between;
`;

export const StyledLink = styled.a`
    align-items: center;
    display: flex;
    font-size: 15px;
    font-weight: bold;
    line-height: 24px;
    margin-top: 24px;
    text-decoration: none;

    svg {
        margin-left: 8px;
    }
`;
